import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CATEGORIES = [
  { id: "top-stories", hi: "टॉप स्टोरीज़", accent: "#FFD400" },
  { id: "india", hi: "भारत", accent: "#FF453A" },
  { id: "world", hi: "विश्व", accent: "#0A84FF" },
  { id: "sports", hi: "खेल", accent: "#30D158" },
  { id: "business", hi: "व्यापार", accent: "#FFD60A" },
  { id: "entertainment", hi: "मनोरंजन", accent: "#BF5AF2" },
  { id: "tech", hi: "टेक", accent: "#64D2FF" },
  { id: "video", hi: "वीडियो", accent: "#FF375F" },
];

export const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.hi || id;
export const catAccent = (id) => CATEGORIES.find((c) => c.id === id)?.accent || "#FFD400";

export const fetchArticles = (params = {}) =>
  axios.get(`${API}/articles`, { params }).then((r) => r.data);
export const fetchArticle = (id) =>
  axios.get(`${API}/articles/${id}`).then((r) => r.data);
const authAxios = axios.create({ baseURL: API, withCredentials: true });
authAxios.interceptors.request.use((config) => {
  const t = localStorage.getItem("khabrik-token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
authAxios.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && !orig._retried && !orig.url.includes("/auth/")) {
      orig._retried = true;
      try {
        const { data } = await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        if (data.access_token) localStorage.setItem("khabrik-token", data.access_token);
        return authAxios(orig);
      } catch {}
    }
    return Promise.reject(error);
  }
);

export const adminLogin = async (email, password) => {
  const { data } = await authAxios.post(`/auth/login`, { email, password });
  if (data.access_token) localStorage.setItem("khabrik-token", data.access_token);
  return data;
};
export const adminLogout = async () => {
  try {
    await authAxios.post(`/auth/logout`);
  } catch {}
  localStorage.removeItem("khabrik-token");
};
export const adminMe = () => authAxios.get(`/auth/me`).then((r) => r.data);
export const fetchSubscribers = () => authAxios.get(`/subscribers`).then((r) => r.data);
export const deleteSubscriber = (id) => authAxios.delete(`/subscribers/${id}`).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  authAxios.post(`/auth/change-password`, { current_password, new_password }).then((r) => r.data);
export const getInstagramConfig = () => authAxios.get(`/instagram/config`).then((r) => r.data);
export const saveInstagramConfig = (access_token, ig_user_id) =>
  authAxios.post(`/instagram/config`, { access_token, ig_user_id }).then((r) => r.data);
export const syncInstagram = () => authAxios.post(`/instagram/sync`, {}, { timeout: 120000 }).then((r) => r.data);
export const getYoutubeConfig = () => authAxios.get(`/youtube/config`).then((r) => r.data);
export const saveYoutubeConfig = (channel_url, ai_articles, auto_publish) =>
  authAxios.post(`/youtube/config`, { channel_url, ai_articles, auto_publish }, { timeout: 60000 }).then((r) => r.data);
export const syncYoutube = () => authAxios.post(`/youtube/sync`, {}, { timeout: 300000 }).then((r) => r.data);
export const reclassifyYoutube = () => authAxios.post(`/youtube/reclassify`, {}, { timeout: 300000 }).then((r) => r.data);

export const fetchAllArticles = () =>
  authAxios.get(`/articles/all`).then((r) => r.data);
export const createArticle = (data) =>
  authAxios.post(`/articles`, data).then((r) => r.data);
export const updateArticle = (id, data) =>
  authAxios.put(`/articles/${id}`, data).then((r) => r.data);
export const deleteArticle = (id) =>
  authAxios.delete(`/articles/${id}`).then((r) => r.data);
export const searchArticles = (q) =>
  axios.get(`${API}/articles/search`, { params: { q } }).then((r) => r.data);
export const likeArticle = (id) =>
  axios.post(`${API}/articles/${id}/like`).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  axios.post(`${API}/subscribe`, { email }).then((r) => r.data);

const BM_KEY = "khabrik-bookmarks";
export const getBookmarks = () => JSON.parse(localStorage.getItem(BM_KEY) || "[]");
export const isBookmarked = (id) => getBookmarks().includes(id);
export const toggleBookmark = (id) => {
  const list = getBookmarks();
  const next = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
  localStorage.setItem(BM_KEY, JSON.stringify(next));
  return next.includes(id);
};

export const timeAgo = (iso) => {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 3600) return `${Math.max(1, Math.floor(diff / 60))} मिनट पहले`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} घंटे पहले`;
  return `${Math.floor(diff / 86400)} दिन पहले`;
};

export const readTime = (content) =>
  `${Math.max(1, Math.ceil((content || "").split(/\s+/).length / 180))} मिनट`;
